(() => {
  function init(root = document) {
    root.querySelectorAll('[data-qa-size-guide]').forEach(guide => {
      const select = guide.querySelector('[data-qa-size-unit]');
      if (guide.dataset.initialized) return;
      const updateUnit = () => guide.querySelectorAll('[data-qa-size-table]').forEach(table => { table.hidden = table.dataset.qaSizeTable !== select.value; });
      select.closest('label').hidden = false;
      select.addEventListener('change', updateUnit);
      updateUnit(); guide.dataset.initialized = 'true';
    });
    root.querySelectorAll('[data-qa-product]').forEach(page => {
      if (page.dataset.initialized) return;
      const variants = JSON.parse(page.querySelector('[data-qa-variants]').textContent);
      const media = JSON.parse(page.querySelector('[data-qa-media]').textContent);
      const native = page.querySelector('select[name="id"]');
      const options = [...page.querySelectorAll('[data-option-index]')];
      const form = page.querySelector('.qa-buy-form');
      const button = form.querySelector('[name="add"]');
      const status = page.querySelector('[data-qa-availability]');
      const main = page.querySelector('[data-qa-main-image]');
      const thumbnails = page.querySelector('.qa-thumbnails');
      const caption = page.querySelector('[data-qa-image-caption]');
      const heading = page.querySelector('.qa-product-heading');
      const sticky = page.querySelector('[data-qa-sticky-purchase]');
      const stickyAction = page.querySelector('[data-qa-sticky-action]');
      const stickyOptions = page.querySelector('[data-qa-sticky-options]');
      const stickyPrice = page.querySelector('[data-qa-sticky-price]');
      const quantity = form.querySelector('[name="quantity"]');
      const footer = document.querySelector('footer');
      const mobile = matchMedia('(max-width: 749px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let selectedVariant;
      let stickyFrame = 0;
      function updateSticky() {
        if (!sticky) return;
        const rect = button.getBoundingClientRect();
        const headerPast = heading.getBoundingClientRect().bottom < 0;
        const actionVisible = rect.top < innerHeight && rect.bottom > 0;
        const footerVisible = footer && footer.getBoundingClientRect().top < innerHeight;
        const dialogOpen = document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]');
        sticky.hidden = !mobile.matches || !headerPast || actionVisible || !!footerVisible || !!dialogOpen;
        stickyOptions.textContent = selectedVariant ? selectedVariant.options.filter(v => v !== 'Default Title').join(' / ') : options.map(s => s.value).join(' / ') + ' — unavailable';
        const count = Math.max(1, Number(quantity.value) || 1);
        stickyPrice.textContent = selectedVariant ? (count > 1 ? count + ' × ' : '') + selectedVariant.price : 'Choose another option';
        const add = rect.bottom <= 0 && selectedVariant?.available;
        stickyAction.dataset.action = add ? 'add' : 'choose';
        stickyAction.textContent = add ? 'Add to cart' : options.length ? 'Choose options' : 'View item';
      }
      function queueSticky() {
        if (stickyFrame) return;
        stickyFrame = requestAnimationFrame(() => { stickyFrame = 0; updateSticky(); });
      }
      if (sticky) {
        stickyAction.addEventListener('click', () => {
          if (stickyAction.dataset.action === 'add' && selectedVariant?.available) {
            if (!form.checkValidity()) {
              form.scrollIntoView({behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center'});
              form.reportValidity();
              return;
            }
            form.requestSubmit(button);
          } else {
            const target = options[0] || quantity;
            target.focus({preventScroll:true});
            form.scrollIntoView({behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center'});
          }
        });
        document.addEventListener('scroll', queueSticky, {passive:true});
        window.addEventListener('resize', queueSticky, {passive:true});
        quantity.addEventListener('input', updateSticky);
        page.addEventListener('toggle', queueSticky, true);
        main.addEventListener('load', queueSticky);
        if (window.ResizeObserver) new ResizeObserver(queueSticky).observe(page);
      }
      page.querySelectorAll('[data-qa-size-help]').forEach(link => link.addEventListener('click', event => {
        const guide = page.querySelector('[data-qa-size-guide-panel] details');
        if (!guide) return;
        event.preventDefault();
        guide.open = true;
        guide.querySelector('summary').focus({preventScroll:true});
        guide.scrollIntoView({behavior: reducedMotion.matches ? 'auto' : 'smooth', block:'start'});
      }));
      if (media.images.some(item => item.campaignType === 'apparel-model')) {
        main.closest('.qa-gallery').insertBefore(thumbnails, main.closest('a'));
        thumbnails.classList.add('qa-thumbnails-top');
      }
      let lastGallery = '';
      let selectedModelView = '';

      function gallery(variant) {
        const indices = [...(media.variantImages[String(variant.id)] || [])];
        const settingPosition = indices.findIndex(index => media.images[index]?.campaignType === 'drinkware-setting');
        if (settingPosition > 0) indices.unshift(...indices.splice(settingPosition, 1));
        const modelViews = indices.filter(index => media.images[index]?.campaignType === 'apparel-model');
        if (modelViews.length) indices.splice(0, indices.length, ...modelViews, ...indices.filter(index => !modelViews.includes(index)));
        const signature = indices.join(',');
        if (!indices.length || signature === lastGallery) return;
        lastGallery = signature;
        main.closest('a').classList.toggle('qa-apparel-gallery', modelViews.length > 0);
        thumbnails.replaceChildren();
        const matchingView = selectedModelView ? indices.findIndex(index => media.images[index]?.view === selectedModelView) : -1;
        const activePosition = matchingView >= 0 ? matchingView : 0;
        const show = (item, active) => {
          selectedModelView = item.campaignType === 'apparel-model' ? item.view : '';
          main.src = item.src;
          main.alt = item.alt;
          main.closest('a').href = item.src;
          main.classList.toggle('qa-lifestyle-photo', item.kind === 'campaign');
          caption.textContent = item.caption || (item.kind === 'campaign' ? 'Styled on an AI-generated model. See the product views for print details.' : 'Select a photo to see another angle. Open the main image for a closer look.');
          thumbnails.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === active)));
        };
        for (const [position, index] of indices.entries()) {
          const item = media.images[index];
          if (!item) continue;
          const thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.setAttribute('aria-label', 'Show photo ' + (position + 1) + ': ' + item.alt);
          thumb.setAttribute('aria-pressed', String(position === activePosition));
          const image = new Image(100, 125);
          image.src = item.src; image.alt = ''; image.loading = 'lazy';
          thumb.append(image); thumbnails.append(thumb);
          if (item.label) {
            const label = document.createElement('span');
            label.className = 'qa-photo-label';
            label.textContent = item.label;
            thumb.append(label);
          }
          thumb.addEventListener('click', () => show(item, thumb));
          if (position === activePosition) show(item, thumb);
        }
      }
      function update(variant, changeUrl = true) {
        selectedVariant = variant;
        native.disabled = !variant;
        button.disabled = !variant?.available;
        button.textContent = !variant ? 'Unavailable combination' : variant.available ? 'Add to cart' : 'Sold out';
        status.textContent = !variant ? 'This combination is not offered. Choose another option.' : variant.available ? '' : 'This option is currently sold out.';
        if (!variant) {
          page.querySelector('[data-qa-price]').textContent = 'Unavailable';
          page.querySelector('[data-qa-compare]').hidden = true;
          const colorIndex = options.findIndex(select => select.dataset.optionName.toLowerCase() === 'color');
          const colorPreview = colorIndex < 0 ? null : variants.find(v => v.options[colorIndex] === options[colorIndex].value);
          if (colorPreview) gallery(colorPreview);
          updateSticky();
          return;
        }
        native.value = String(variant.id);
        page.querySelector('[data-qa-price]').textContent = variant.price;
        const compare = page.querySelector('[data-qa-compare]');
        compare.hidden = !variant.compare; compare.textContent = variant.compare || '';
        options.forEach((select, i) => { select.value = variant.options[i]; });
        gallery(variant);
        if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
        updateSticky();
      }
      options.forEach(select => select.addEventListener('change', () => {
        const chosen = options.map(s => s.value);
        update(variants.find(v => v.options.every((value, index) => value === chosen[index])));
      }));
      form.addEventListener('submit', event => {
        const selected = variants.find(v => String(v.id) === native.value);
        if (native.disabled || !selected?.available) { event.preventDefault(); status.textContent = 'Choose an available option before adding this item.'; }
      });
      update(variants.find(v => String(v.id) === native.value) || variants[0], false);
      page.querySelector('.qa-native-variants').hidden = true;
      page.querySelector('.qa-option-selectors').hidden = false;
      updateSticky();
      page.dataset.initialized = 'true';
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
